export enum RiskRowEntityType {
    ORG = "ORG",
    BROKER = "BROKER",
    BRANCH = "BRANCH",
    ADVISER = "ADVISER",
    CLIENT = "CLIENT"
}
